import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <path d='M8.8421 17.3333V6.66667C8.8421 5.2 9.96632 4 11.3684 4H22.7368V2.66667C22.7368 1.2 21.6 0 20.2105 0H2.52632C1.12421 0 0 1.2 0 2.66667V21.3333C0 22.8 1.12421 24 2.52632 24H20.2105C21.6 24 22.7368 22.8 22.7368 21.3333V20H11.3684C9.96632 20 8.8421 18.8 8.8421 17.3333ZM12.6316 6.66667C11.9368 6.66667 11.3684 7.26667 11.3684 8V16C11.3684 16.7333 11.9368 17.3333 12.6316 17.3333H24V6.66667H12.6316ZM16.4211 14C15.3726 14 14.5263 13.1067 14.5263 12C14.5263 10.8933 15.3726 10 16.4211 10C17.4695 10 18.3158 10.8933 18.3158 12C18.3158 13.1067 17.4695 14 16.4211 14Z' />
  </>,
  'Wallet'
)
